export default __webpack_public_path__ + "static/media/sygnet_pb.31786d25.svg";